var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1717_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1C24.271 1 31 7.729 31 16C31 24.271 24.271 31 16 31C7.729 31 1 24.271 1 16C1 7.729 7.729 1 16 1ZM16 0C7.163 0 0 7.163 0 16C0 24.837 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1717_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8469 16.4375L19.2462 13.7217H16.7459V11.9609C16.7459 11.2168 17.0947 10.4932 18.214 10.4932H19.3503V8.18457C19.3503 8.18457 18.3125 8 17.3281 8C15.2694 8 13.925 9.30078 13.925 11.6621V13.7305H11.644V16.4375H13.9334V23H16.7459V16.4375H18.8469Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1717_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1717_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 15,
    fill: "white",
    transform: "translate(11 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon2);
export default __webpack_public_path__ + "static/media/FacebookIcon2.a9b3c1b6f360bb799f40f72852a75ddd.svg";
export { ForwardRef as ReactComponent };